import { useContext } from 'react';
import { GetAccessTokenContext } from '../context';
import { NotWrappedError } from '../functions';
var useGetAccessToken = function () {
    var context = useContext(GetAccessTokenContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useGetAccessToken;
//# sourceMappingURL=useGetAccessToken.js.map